(function(angular, _) {
    'use strict';

    /**
     * @ngdoc object
     * @name DynamicDropdownController
     * @description The controller of dynamic drop down component
     */
    class DynamicDropdownController {
        static get $inject() {
            return [];
        }

        $onInit() {
            if (!_.isFunction(this.renderItem)) {
                this.renderItem = (context) => context.item;
            }
            if (!_.isFunction(this.renderQaTag)) {
                this.renderQaTag = () => '';
            }
            if (!_.isFunction(this.getTooltip)) {
                this.getTooltip = _.constant(null);
            }
            if (!_.isFunction(this.isItemDisabled)) {
                this.isItemDisabled = _.constant(false);
            }

            this.setSelectedItem_();
        }

        setSelectedItem_() {
            this.selectedItem = this.initiallySelectedItem || '';
        }

        $onChanges(changelist) {
            if (_.hasIn(changelist, 'initiallySelectedItem.currentValue') && !changelist.initiallySelectedItem.isFirstChange()) {
                this.setSelectedItem_();
            }
        }

        selectItem(item) {
            if (this.isItemDisabled({item})) {
                return;
            }

            this.onItemSelect({item, previousItem: this.selectedItem});
            this.selectedItem = item;
        }

        isItemSelected(item) {
            return _.isEqual(this.renderItem({item: this.selectedItem}), this.renderItem({item}));
        }
    }

    angular.module('wtUi.wtDynamicDropdown').component('dynamicDropdown', {
        controller: DynamicDropdownController,
        controllerAs: '$ctrl',
        templateUrl: 'src/dynamic-dropdown/dynamic-dropdown.component.html',
        bindings: {
            items: '<',
            getTooltip: '&?',
            renderItem: '&?',
            renderQaTag: '&?',
            onItemSelect: '&',
            isItemDisabled: '&?',
            initiallySelectedItem: '<?'
        }
    });
})(window.angular, window._);
